import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import content from "../content/content.json";

const OurStory = () => {
  const [offsetX, setOffsetX] = useState(0);
  const { ourStory, shared } = content;

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setOffsetX(-(scrollY * 0.1));
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="relative bg-[#1C1F2B] text-white w-full overflow-hidden">
      <div
        className="absolute top-16 left-0 w-full text-center font-extrabold text-[20vw] md:text-[28vw] text-[#252837] leading-none tracking-tighter whitespace-nowrap pointer-events-none select-none"
        style={{
          transform: `translateX(${offsetX}px)`,
          transition: "transform 0.3s linear",
        }}
      >
        {ourStory.watermark}
      </div>

      <div className="relative z-10 max-w-7xl mx-auto flex flex-col md:flex-row items-start justify-between gap-10 px-6 py-24 md:py-28">
        <div className="md:w-1/2">
          <h3 className="text-[#A1ACBD] font-semibold text-lg mb-4">{ourStory.eyebrow}</h3>
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-extrabold leading-tight">{ourStory.heading}</h2>
        </div>

        <div className="md:w-1/2 text-md text-[#C9CED9] leading-relaxed">
          <div className="mb-8 space-y-5 text-sm sm:text-base">
            {ourStory.description.map((item, i) => (
              <div key={i}>
                <p className="font-semibold text-white">{item.title}</p>
                <p className="text-[#C9CED9]">{item.body}</p>
              </div>
            ))}
          </div>

          <Link to="/about" className="group relative overflow-hidden border border-white px-6 py-3 font-semibold rounded-none inline-flex items-center gap-2 text-sm sm:text-base">
            <span className="relative z-10 text-white transition-colors duration-300">{ourStory.button}</span>
            <span className="relative z-10 text-white text-lg transition-colors duration-300">{shared.arrow}</span>
          </Link>
        </div>
      </div>

      {/* <div className="relative w-full flex justify-center items-center bg-[#1C1F2B] px-4 py-12 sm:py-16">
        <div className="w-full max-w-5xl aspect-video relative rounded-lg overflow-hidden shadow-lg border border-[#2E3242]">
          <video className="w-full h-full object-cover" poster={ourStory.videoPoster}>
            <source src="your-video.mp4" type="video/mp4" />
            {ourStory.videoFallback}
          </video>

          <div className="absolute inset-0 flex items-center justify-center bg-black/40 hover:bg-black/50 transition duration-300 cursor-pointer">
            <button className="w-16 h-16 sm:w-20 sm:h-20 bg-red-600 rounded-full flex items-center justify-center text-white text-3xl sm:text-4xl hover:scale-105 transition-transform duration-300">
              {shared.playIcon}
            </button>
          </div>

          <div className="absolute top-3 left-3 sm:top-4 sm:left-4 bg-black/60 text-white text-xs sm:text-sm font-semibold px-3 py-1.5 rounded">
            {ourStory.videoTitle}
          </div>
        </div>
      </div> */}
    </section>
  );
};

export default OurStory;

